__turbopack_context__.v({
  "bodyContent": "index-module__Z8lDea__bodyContent",
  "centeredSection": "index-module__Z8lDea__centeredSection",
  "closeButton": "index-module__Z8lDea__closeButton",
  "contentWrapper": "index-module__Z8lDea__contentWrapper",
  "ctaButton": "index-module__Z8lDea__ctaButton",
  "divider": "index-module__Z8lDea__divider",
  "dropdownFadeIn": "index-module__Z8lDea__dropdownFadeIn",
  "dropdownGroup": "index-module__Z8lDea__dropdownGroup",
  "dropdownMenu": "index-module__Z8lDea__dropdownMenu",
  "dropdownOption": "index-module__Z8lDea__dropdownOption",
  "dropdownTrigger": "index-module__Z8lDea__dropdownTrigger",
  "dropdownWrapper": "index-module__Z8lDea__dropdownWrapper",
  "fadeInAnimation": "index-module__Z8lDea__fadeInAnimation",
  "footer": "index-module__Z8lDea__footer",
  "footerDetails": "index-module__Z8lDea__footerDetails",
  "footerRow": "index-module__Z8lDea__footerRow",
  "footerSubtitle": "index-module__Z8lDea__footerSubtitle",
  "footerTitle": "index-module__Z8lDea__footerTitle",
  "header": "index-module__Z8lDea__header",
  "headerButtonWrapper": "index-module__Z8lDea__headerButtonWrapper",
  "headerContent": "index-module__Z8lDea__headerContent",
  "headerImageWrapper": "index-module__Z8lDea__headerImageWrapper",
  "headerSubtitle": "index-module__Z8lDea__headerSubtitle",
  "headerTextContent": "index-module__Z8lDea__headerTextContent",
  "headerTitle": "index-module__Z8lDea__headerTitle",
  "heroImage": "index-module__Z8lDea__heroImage",
  "lgHidden": "index-module__Z8lDea__lgHidden",
  "modalContainer": "index-module__Z8lDea__modalContainer",
  "modalContentWithPadding": "index-module__Z8lDea__modalContentWithPadding",
  "modalOverlay": "index-module__Z8lDea__modalOverlay",
  "optionTitle": "index-module__Z8lDea__optionTitle",
  "optionValue": "index-module__Z8lDea__optionValue",
  "serialNumberInput": "index-module__Z8lDea__serialNumberInput",
  "serialNumberTip": "index-module__Z8lDea__serialNumberTip",
  "smHidden": "index-module__Z8lDea__smHidden",
  "step": "index-module__Z8lDea__step",
  "stepIcon": "index-module__Z8lDea__stepIcon",
  "stepsSection": "index-module__Z8lDea__stepsSection",
  "termsSection": "index-module__Z8lDea__termsSection",
  "translateUpAnimation": "index-module__Z8lDea__translateUpAnimation",
  "triggerContent": "index-module__Z8lDea__triggerContent",
  "triggerTitle": "index-module__Z8lDea__triggerTitle",
  "triggerValue": "index-module__Z8lDea__triggerValue",
  "uhxBonusBanner": "index-module__Z8lDea__uhxBonusBanner",
});
